/**
 * Built-in sticker / decoration artwork for the custom studio's "+" menu. Each is a small inline
 * SVG served as a data-URI (same-origin, so the export canvas never taints). Colours come from the
 * shared creative palette rather than raw literals.
 */
import { CREATIVE_SWATCHES } from '../../theme/tokens';

const [WHITE, , ORANGE, RED, GREEN, BLUE, PURPLE, GOLD, MAGENTA] = CREATIVE_SWATCHES;

const svg = (body: string): string =>
  `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">${body}</svg>`)}`;

export interface StickerAsset {
  id: string;
  label: string;
  src: string;
}

export const STICKERS: readonly StickerAsset[] = [
  {
    id: 'star',
    label: 'Star',
    src: svg(`<path d="M32 4l7.6 17.2L58 23l-13.6 12 4 19L32 44.5 15.6 54l4-19L6 23l18.4-1.8z" fill="${GOLD}"/>`),
  },
  {
    id: 'sparkle',
    label: 'Sparkle',
    src: svg(
      `<path d="M32 6c2.2 13.6 12.2 23.6 26 25.8-13.8 2.2-23.8 12.2-26 26-2.2-13.8-12.2-23.8-26-26 13.8-2.2 23.8-12.2 26-25.8z" fill="${PURPLE}"/>`,
    ),
  },
  {
    id: 'heart',
    label: 'Heart',
    src: svg(
      `<path d="M32 56S8 40.5 8 24.5C8 15.9 14.6 10 21 10c5 0 9 3 11 7 2-4 6-7 11-7 6.4 0 13 5.9 13 14.5C56 40.5 32 56 32 56z" fill="${RED}"/>`,
    ),
  },
  { id: 'bolt', label: 'Bolt', src: svg(`<path d="M36 4L14 36h13l-5 24 25-34H36l6-22z" fill="${GOLD}"/>`) },
  { id: 'crown', label: 'Crown', src: svg(`<path d="M6 20l12 12L32 12l14 20 12-12-6 34H12z" fill="${ORANGE}"/>`) },
  {
    id: 'badge',
    label: 'Badge',
    src: svg(
      `<circle cx="32" cy="26" r="20" fill="${GREEN}"/><path d="M24 42l-6 18 14-8 14 8-6-18z" fill="${GREEN}" opacity="0.75"/><circle cx="32" cy="26" r="9" fill="${WHITE}" opacity="0.9"/>`,
    ),
  },
  {
    id: 'tag',
    label: 'Sale tag',
    src: svg(
      `<path d="M8 32L32 8h22a2 2 0 0 1 2 2v22L32 56z" fill="${RED}"/><circle cx="44" cy="20" r="5" fill="${WHITE}"/>`,
    ),
  },
  {
    id: 'ring',
    label: 'Ring',
    src: svg(`<circle cx="32" cy="32" r="24" fill="none" stroke="${BLUE}" stroke-width="8"/>`),
  },
  { id: 'dot', label: 'Dot', src: svg(`<circle cx="32" cy="32" r="22" fill="${MAGENTA}"/>`) },
];
